import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=4542b349&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=ts"
export * from "./Customers.vue?vue&type=script&lang=ts"
import style0 from "./Customers.vue?vue&type=style&index=0&id=4542b349&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4542b349",
  null
  
)

export default component.exports